import { FormControl } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { logEvent } from 'lib/tracking/segment'
import * as $ from './ProductCheckboxGroup.styled'
import * as events from './ProductCheckboxGroup.events'
import { useProductCheckboxGroupOptions } from './hooks/useProductCheckboxGroupOptions/useProductCheckboxGroupOptions'

export interface ProductCheckboxGroupValues {
  interestedIn: {
    billPay?: boolean
    workingCapital?: boolean
    purchasing: boolean
    landedCosts?: boolean
  }
}

export const ProductCheckboxGroup: React.FC = () => {
  const { t } = useTranslation()
  const form = useFormContext<ProductCheckboxGroupValues>()
  const { productOptions } = useProductCheckboxGroupOptions()

  return (
    <Controller
      name="interestedIn"
      control={form.control}
      rules={{
        validate: (value) => Object.values(value).some((bool) => bool),
      }}
      render={({ field, fieldState }) => {
        const error = Boolean(fieldState.error)

        return (
          <FormControl error={error} component="fieldset" variant="standard" data-testid="product-checkbox-group">
            <$.FormGroup>
              {productOptions.map(
                ({ key, fieldName, visible, checked, titleKey }) =>
                  visible && (
                    <$.Label
                      key={key}
                      data-testid={key}
                      control={
                        <$.CheckboxControl
                          error={error}
                          checked={checked}
                          onChange={(e) => {
                            field.onChange({ ...field.value, [fieldName]: e.target.checked })
                            void logEvent(events.PRODUCT_SELECT, { product: key })
                          }}
                        />
                      }
                      label={<$.Title>{t(titleKey)}</$.Title>}
                    />
                  ),
              )}
            </$.FormGroup>
          </FormControl>
        )
      }}
    />
  )
}
